import { createUseStyles } from 'react-jss'

import { fontWeightRegular } from '../../../styles/typography'
import { textEllipsis } from '../../../styles/mixins/text'

const useStyles = createUseStyles({
  value: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: fontWeightRegular
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 5,
    width: ({ bigIcon }) => (bigIcon ? 32 : 16),
    height: ({ bigIcon }) => (bigIcon ? 32 : 16),

    '& svg, & img': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  },
  info: {
    width: '100%',
    overflow: 'hidden'
  },
  label: {
    ...textEllipsis()
  }
})

export default useStyles
